import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22964 23321"
    {...props}
  >
    <defs>
      <style>{".str0{stroke:#2b2a29;stroke-width:666.316}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278273888">
        <rect
          width={1239}
          height={8435}
          x={10863}
          y={333}
          className="fill"
          rx={1239}
          ry={1589}
          style={{
            fill: "#1c1b17",
            strokeWidth: 666.316,
          }}
        />
        <path
          d="M14580 1239c1833 526 3473 1508 4785 2814 2018 2007 3266 4781 3266 7843 0 3063-1248 5836-3266 7843-2017 2007-4805 3249-7883 3249s-5866-1242-7884-3249c-2017-2007-3265-4780-3265-7843 0-3062 1248-5836 3265-7843 1313-1306 2953-2288 4785-2814l451 1087c-1690 462-3201 1355-4405 2553-1805 1796-2922 4277-2922 7017 0 2741 1117 5222 2922 7018 1805 1795 4299 2907 7053 2907s5248-1112 7053-2907c1805-1796 2922-4277 2922-7018 0-2740-1117-5221-2922-7017-1204-1198-2715-2091-4405-2553l450-1087z"
          className="fill"
          style={{
            fill: "#1c1b17",
            fillRule: "nonzero",
            strokeWidth: 666.316,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
